module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-200.0cad310b.woff";